/**
 * Collection Scroll Position Preservation
 * Saves scroll position when navigating to product pages and restores it on back navigation.
 */
(function() {
  const STORAGE_PREFIX = 'collection_scroll_';

  /**
   * Get the storage key for the current collection page
   * Uses pathname to support different collection pages and pagination
   */
  function getStorageKey() {
    return STORAGE_PREFIX + window.location.pathname;
  }

  /**
   * Check if the current navigation is a back/forward navigation
   * Uses multiple methods for broad browser support
   */
  function isBackNavigation() {
    // Modern browsers: Navigation Timing API Level 2
    if (window.performance && window.performance.getEntriesByType) {
      const navEntries = window.performance.getEntriesByType('navigation');
      if (navEntries.length > 0 && navEntries[0].type === 'back_forward') {
        return true;
      }
    }

    // Fallback: deprecated performance.navigation (still widely supported)
    if (window.performance && window.performance.navigation) {
      // TYPE_BACK_FORWARD = 2
      if (window.performance.navigation.type === 2) {
        return true;
      }
    }

    return false;
  }

  /**
   * Restore scroll position if conditions are met
   * Only restores on back/forward navigation or pageshow with persisted = true
   */
  function restoreScrollPosition() {
    const storageKey = getStorageKey();
    const savedPosition = sessionStorage.getItem(storageKey);

    if (savedPosition && isBackNavigation()) {
      const position = parseInt(savedPosition, 10);

      // Use requestAnimationFrame to ensure DOM is ready and images have layout
      requestAnimationFrame(() => {
        window.scrollTo(0, position);
        // Clear the stored position after restoring
        sessionStorage.removeItem(storageKey);
      });
    }
  }

  /**
   * Save the current scroll position for this collection page
   */
  function saveScrollPosition() {
    const storageKey = getStorageKey();
    sessionStorage.setItem(storageKey, window.scrollY.toString());
  }

  /**
   * Initialize scroll position saving for product card clicks
   */
  function initScrollSaving() {
    // Handle clicks on product card links
    document.addEventListener('click', function(event) {
      const productLink = event.target.closest('product-card a[href*="/products/"]');

      if (productLink) {
        saveScrollPosition();
      }
    });
  }

  /**
   * Handle pageshow event for bfcache (back-forward cache) restoration
   */
  window.addEventListener('pageshow', function(event) {
    // event.persisted is true if page is loaded from bfcache
    if (event.persisted) {
      const storageKey = getStorageKey();
      const savedPosition = sessionStorage.getItem(storageKey);

      if (savedPosition) {
        const position = parseInt(savedPosition, 10);
        requestAnimationFrame(() => {
          window.scrollTo(0, position);
          sessionStorage.removeItem(storageKey);
        });
      }
    }
  });

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initScrollSaving();
      restoreScrollPosition();
    });
  } else {
    initScrollSaving();
    restoreScrollPosition();
  }
})();
